<template>
<div class="bbox">
      <div class="bbox" v-if='list.length>0'>
        <el-carousel indicator-position="out" :autoplay='true' height='420px'  ref='img'>
            <el-carousel-item v-for="(item,aind) in list" :key="aind">
                <div class="item pinter" @click="openUrl(item.slideshowLink)">
                    <div class=" imgbox" >
                        <img :src="$fileAccessHttpUrl(item.slideshowImg)" />
                    </div>
                    <div class="tex overf-elli" v-if='item.slideshowName' :title="item.slideshowName">{{item.slideshowName}}</div>
                </div>
            </el-carousel-item>
        </el-carousel>
      </div>
</div>
  
</template>
<script>
export default {
    props:['list'],
    inject:["reload"],
    data(){
        return{ }
    },
    
    mounted(){

    },
    methods:{
        onrest(){
            this.reload()
        },
        openUrl(url){ 
            window.open(url)
        },
    }
  
}
</script>
<style lang='scss' scoped>
.el-carousel--horizontal{
    overflow: hidden;
}
.bbox{
   width: 630px;
   padding-left: 5px;
   padding-top: 5px;
   overflow: hidden;
   position: relative;
}
.item{
    width: 630px;
    height: 100%;
    color: #333333;
    font-size:14px;
    position: relative;
    .tex{
        position: absolute;
        width: 100%;
        left: 0;
        bottom: 0;
        height: 56px;
        line-height: 56px;
        background-color: rgba(0, 0, 0, 0.5);
        color: #fff;
        padding-left: 10px;
}
    .imgbox{
        width: 100%;
        height: 100%;
        overflow: hidden;
        img{
            width: 100%;
            height: auto;
        }
    }
 }
</style>
